// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__U95j6","content":"not-allowed_content__1cazP","title":"not-allowed_title__ny1ct"};